import {
  deleteUserRegistry,
  fetchUserRegistry,
  updateUserRegistry
} from "./services";

export const subscriptionKeys = {
  updatedUser: "ats-user-registry-updated"
};

class Manager {
  constructor() {
    this.subscriptionKeys = subscriptionKeys;

    this.userSettings = {};
  }

  getRibbonState() {
    return fetchUserRegistry("ribbon");
  }

  setRibbonState(state) {
    return updateUserRegistry("ribbon", state);
  }

  setAppState(appId, state) {
    return setUserRegistryValue(`ribbon/${encodeURIComponent(appId)}`, state);
  }

  deleteRibbonState() {
    return deleteUserRegistry("ribbon");
  }

  getUserEntry(key) {
    return fetchUserRegistry(key);
  }

  updateUserEntry(key, value) {
    return updateUserRegistry(key, value);
  }

  deleteUserEntry(key) {
    deleteUserRegistry(key);
  }

  getUserSettings() {
    const keys = ["timezone", "dateFormat"];

    const {promise, cancel} = this.getUserEntry(keys);

    const _promise = promise.then(({data}) => {
      if (!data) {
        return;
      }

      const mapped = {};

      Object.keys(data).forEach(k => {
        if (!data[k]) {
          return;
        }

        mapped[k] = data[k].data;
      });

      this.userSettings = mapped;

      return mapped;
    });

    return {promise: _promise, cancel};
  }
}

const Configuration = () => {
  if (!window.atsSecurityRibbonRegistryManager) {
    window.atsSecurityRibbonRegistryManager = new Manager();
  }
  return window.atsSecurityRibbonRegistryManager;
};

export default Configuration();

export const ManagerClass = Manager;
